import { createSlice } from "@reduxjs/toolkit";

export const centerModalSlice = createSlice({
  name: "centerModal",
  initialState: {
    isOpen: false,
    content: null,
    maxWidth: "",
    fullScreen: false,
    hasCloseBtn: false,
    onClose: () => {},
    desc: null,
    backgroundcolor: null,
    disableClose: false,
  },
  reducers: {
    openCenterModal: (state, { payload }) => {
      state.isOpen = true;
      state.hasCloseBtn = payload?.hasCloseBtn;
      state.onClose = payload?.onClose;
      state.content = payload?.content;
      state.fullScreen = payload?.fullScreen;
      state.desc = payload?.desc;
      state.maxWidth = payload?.maxWidth;
      state.backgroundcolor = payload?.backgroundcolor;
      state.disableClose = payload?.disableClose ?? false;
    },
    closeCenterModal: (state) => {
      state.isOpen = false;
      state.hasCloseBtn = false;
      state.width = "";
      state.onClose = () => {};
      // state.content = null;
      state.fullScreen = false;
      state.desc = null;
      state.backgroundcolor = null;
      state.disableClose = false;
    },
  },
});

export const { openCenterModal, closeCenterModal } = centerModalSlice.actions;

export default centerModalSlice.reducer;
